import { DocumentField } from '@bybeam/platform-types';
import { makeEduConfig } from './baseConfig.js';

const CONFIG = makeEduConfig();

const documentsSection = CONFIG.sections.find(({ key }) => key === 'documents');
const documentsSectionField = documentsSection.questionGroups[0].questions[0]
  .fields[0] as DocumentField;

documentsSection.questionGroups[0].questions[0].copy.intro =
  'Please upload documents to help us verify your enrollment and GPA. Uploaded documents must include your name.';

documentsSectionField.copy.description =
  'Examples include your transcript, class schedule or any other documents that shows your enrollment and GPA.';

export default CONFIG;
